import * as Animate from "react-reveal";
import { ArrowUpRight } from "../../../components/svgs";
import { businessSuccessStories } from "../../../utils/businessSuccessStories";

const SuccessStorySection = () => {
  const story = businessSuccessStories[0];

  return (
    <section className="bg-white py-16 md:py-20 lg:py-24 px-4">
      <div className="container mx-auto">
        <Animate.Fade bottom>
          <p className="flex items-center font-poppins gap-3 text-primary text-sm font-extrabold tracking-widest uppercase mb-6">
            <span className="w-8 h-1 rounded-full bg-secondary inline-block"></span>
            Workforce success story
          </p>
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 items-start mb-12 lg:mb-14">
            <h2 className="lg:col-span-2 text-3xl md:text-4xl lg:text-5xl font-poppins leading-tight font-black max-w-2xl tracking-[-0.03em] text-primary">
              Learning designed for a real capability gap.
            </h2>
            <p className="text-gray text-base font-poppins leading-relaxed lg:pt-2">
              The current Utiva Business programme for {story?.title} focused on
              strengthening Data Visualisation and Data Engineering capability
              through a structured Data Science learning engagement.
            </p>
          </div>
        </Animate.Fade>

        <Animate.Fade bottom>
          <div className="grid grid-cols-1 lg:grid-cols-3 rounded-3xl overflow-hidden shadow-course-feature-lg">
            <div className="lg:col-span-1 bg-primary p-8 md:p-10 flex flex-col justify-center">
              <p className="text-secondary font-poppins text-xs font-extrabold tracking-widest uppercase mb-4">
                {story?.title}
              </p>
              <h3 className="text-white font-poppins font-extrabold text-2xl md:text-3xl leading-tight mb-5">
                From data training to stronger applied capability.
              </h3>
              <p className="text-indigo-100 font-poppins text-sm leading-relaxed mb-7">
                A focused programme built around the tools and data practices
                the team needed to use—not a generic content library.
              </p>
              <a
                href="mailto:business@utiva.io?subject=Discuss a similar programme"
                className="inline-flex items-center gap-2 font-poppins font-extrabold text-secondary hover:opacity-80 transition-opacity"
              >
                Discuss a similar programme
                <ArrowUpRight className="w-3.5 h-3.5" />
              </a>
            </div>

            <div className="lg:col-span-2 bg-hire-tint-blue grid grid-cols-1 sm:grid-cols-3 gap-4 p-6 md:p-8">
              {story?.stats?.map((stat) => (
                <article
                  key={stat.id}
                  className="bg-white rounded-2xl p-6 flex flex-col justify-center"
                >
                  <strong className="block font-poppins text-4xl text-primary font-extrabold mb-2">
                    {stat.value}
                  </strong>
                  <strong className="block font-poppins text-sm text-primary font-bold mb-1">
                    {stat.name?.toLowerCase().includes("course")
                      ? "learning pathways"
                      : stat.name?.toLowerCase().includes("people")
                      ? "people trained"
                      : "weeks"}
                  </strong>
                  <span className="text-gray font-poppins text-xs leading-relaxed">
                    {stat.name}
                  </span>
                </article>
              ))}
            </div>
          </div>
        </Animate.Fade>
      </div>
    </section>
  );
};

export default SuccessStorySection;
